import React, { useEffect } from "react";
import { TbSmartHome } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";

import PanelLayout from "layouts/PanelLayout";
import "styles/teacher.css";

const FAKE_RESULTS = [
  {
    id: 1,
    type: "Standart",
    title: "Qisqa ko‘paytirish formulalari",
    category: "Standart",
  },
  {
    id: 2,
    type: "Logic",
    title: "Tenglamalar testlari",
    category: "Logic",
  },
  {
    id: 3,
    type: "Standart",
    title: "Trigonometriya asoslari",
    category: "Standart",
  },
  {
    id: 4,
    type: "Logic",
    title: "Geometriya testlari",
    category: "Logic",
  },
];

const StudentResultPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const subject = location.state?.subject;

  useEffect(() => {
    if (!subject) navigate("/student");
  }, [subject, navigate]);

  const openResultTable = (item) => {
    navigate(`/student/result-table/${item.id}`, { state: { test: item } });
  };

  return (
    <PanelLayout>
      <div className="subject-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span
              className="breadcrumb-icon"
              onClick={() => navigate("/student")}
            >
              <TbSmartHome />
            </span>
            <span className="divider">/</span>
            <span className="breadcrumb-link" onClick={() => navigate(-1)}>
              {subject?.title || "Fan"}
            </span>
            <span className="divider">/</span>
            <span className="current">Natijalar</span>
          </div>
        </div>

        <div className="test-grid">
          {FAKE_RESULTS.map((item) => (
            <div
              key={item.id}
              className="test-box"
              onClick={() => openResultTable(item)}
            >
              <div className="test-top">
                <div className="badge-group">
                  <span className={`badge ${item.category.toLowerCase()}`}>
                    {item.category}
                  </span>
                </div>
              </div>

              <h4>{item.title}</h4>

              <p className="test-desc">
                Lorem ipsum dolor sit amet consectetur. Nibh vel donec ultricies
                elementum.
              </p>
            </div>
          ))}
        </div>
      </div>
    </PanelLayout>
  );
};

export default StudentResultPage;
